import jwtDecode from "jwt-decode";
import { useDispatch, useSelector } from "react-redux";
import { setAuthorization,
        setAppId,
        setSessionId,
        setUserName,
        setGroupId,
        setRightFormat,
        setRights,  
        setGroupEuId } from "features/commonSlice";
import store from "../store"

const useAuth = () => {

    const state = store.getState();
    const { codecToken } = state.common;

    const dispatch = useDispatch();
    var auth = null;
    if (codecToken !== null) {
        try {
            auth = jwtDecode(codecToken);
        } catch (e) {
            auth = null;
        }
    }
    var isAuthenticated = false; 
    if (auth) {

        isAuthenticated = true;

        dispatch(setAuthorization(auth.Authorization));
        dispatch(setAppId(auth.AppId));
        dispatch(setSessionId(auth.SessionId));
        dispatch(setUserName(auth.UserName));
        dispatch(setGroupId(auth.GroupId));
        dispatch(setRightFormat(auth.RightFormat));
        dispatch(setRights(auth.Rights));
        dispatch(setGroupEuId(auth.GroupEuId));
    }  

    return { isAuthenticated };
};
export default useAuth;